import { render, staticRenderFns } from "./data56.vue?vue&type=template&id=0a764945&scoped=true"
import script from "./data56.vue?vue&type=script&lang=js"
export * from "./data56.vue?vue&type=script&lang=js"
import style1 from "./data56.vue?vue&type=style&index=1&id=0a764945&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a764945",
  null
  
)

export default component.exports